// Centralized localStorage access for auth data, so the api client, AuthContext,
// and Login/Dashboard all agree on the same keys.

export function getToken() {
  return localStorage.getItem("token");
}

export function getUsername() {
  return localStorage.getItem("username");
}

export function getSessionId() {
  return localStorage.getItem("session_id");
}

export function setAuthStorage({ token, username, sessionId }) {
  localStorage.setItem("token", token);
  localStorage.setItem("username", username);
  localStorage.setItem("session_id", sessionId);
}

export function clearAuthStorage() {
  localStorage.removeItem("token");
  localStorage.removeItem("username");
  localStorage.removeItem("session_id");
}
